import type {
    Fiber,
    ITrackReportRoot,
    ITrackReport,
    TrackReportBaseInfo,
} from '../types';
import { loggerError } from '../helpers/logger';
import { getTopMenuCurrentName } from '../../../../component/KDevPageLayout/common/topMenu/PageLayoutTopMenu';
import { getSiderMenuCurrentName } from '../../../../component/KDevPageLayout/common/sider/PageLayoutSider';
import { getHourglassId } from '../helpers/hourglass';
import { InspectorOverlayWrapper } from '../insepector/overlay';
import React from 'react';

export const TrackReportFlag = /**********/ 0b00000001;
export const TrackReportRootFlag = /******/ 0b00000010;
export const TrackReportIgnoreFlag = /****/ 0b00000100;

const inIFrame = window.self !== window.top;

let canParentReport= false;
try {
     canParentReport = Boolean(
        inIFrame && (window as any).top.__getReportTrackCommonParams
    );
} catch(err) {
    console.log(err);
}


export function TrackReportRoot(
    props: React.PropsWithChildren<ITrackReportRoot>
) {
    return [<InspectorOverlayWrapper />, props.children as React.ReactElement];
}
TrackReportRoot.trackReportFlag = TrackReportRootFlag | TrackReportFlag;

export function TrackReport(props: React.PropsWithChildren<ITrackReport>) {
    return props.children as React.ReactElement;
}
TrackReport.trackReportFlag = TrackReportFlag;

export function TrackReportIgnore(
    props: React.PropsWithChildren<ITrackReportRoot>
) {
    return props.children as React.ReactElement;
}
TrackReportIgnore.trackReportFlag = TrackReportIgnoreFlag | TrackReportFlag;

export function isTrackReportRoot(fiber: Fiber) {
    if (!fiber.type?.trackReportFlag) return false;
    const trackReportFlag = fiber.type?.trackReportFlag as number;

    if ((trackReportFlag & TrackReportRootFlag) === TrackReportRootFlag) {
        return true;
    }

    return false;
}

export function isTrackReportIgnore(fiber: Fiber) {
    if (!fiber.type?.trackReportFlag) return false;
    const trackReportFlag = fiber.type?.trackReportFlag as number;

    if ((trackReportFlag & TrackReportIgnoreFlag) === TrackReportIgnoreFlag) {
        return true;
    }

    return false;
}

export function getTrackInfo(fiber: Fiber): string | null {
    const trackReportFlag = fiber.type?.trackReportFlag as number;

    if (!trackReportFlag) return null;

    if ((trackReportFlag & TrackReportFlag) !== TrackReportFlag) return null;

    const trackInfo = fiber.memoizedProps.trackInfo;
    let retTrackInfoStr = String();

    if (typeof trackInfo === 'function') {
        try {
            retTrackInfoStr = String(trackInfo?.() || '');
        } catch (err) {
            loggerError(err);
        }
    } else {
        retTrackInfoStr = String(trackInfo || '');
    }

    return retTrackInfoStr;
}

export function genTrackReportInfo(params: {
    targetInfo: string;
    trackInfoList?: string[];
}) {
    const { targetInfo, trackInfoList } = params || {};
    const res: TrackReportBaseInfo = {};

    if (!targetInfo) return null;
    if (targetInfo) res.k_track_e = targetInfo;

    const reverseTrackList = (trackInfoList || []).reverse();

    if (inIFrame) {
        const iframePathname = location.pathname;
        reverseTrackList.unshift(`iframe(${iframePathname})`);
    }

    for (let i = 0; i < reverseTrackList.length; ++i) {
        res[`k_track_s` + i] = reverseTrackList[i];
    }
    res[`k_track_msg`] = reverseTrackList.join('/');

    if (inIFrame && canParentReport) {
        try {
            Object.assign(
                res,
                (window.top as any).__getReportTrackCommonParams()
            );
        } catch(err) {
            console.log(err);
        }
    } else {
        Object.assign(res, genCommonParams());
    }

    return res;
}

function genCommonParams() {
    const res: TrackReportBaseInfo = {};

    res['k_top_menu'] = getTopMenuCurrentName();
    res['k_sider_menu'] = getSiderMenuCurrentName();
    res['k_hourglass_id'] = getHourglassId();

    return res;
}

export function genTrackUrlInfo(urlObj: URL): TrackReportBaseInfo | null {
    try {
        const { origin, pathname } = urlObj;

        return {
            k_track_to_url: urlObj.toString(),
            k_track_to_path: `${origin}${pathname}`,
        };
    } catch (err) {
        loggerError(err);
    }

    return null;
}

if (!inIFrame) {
    (window as any).__getReportTrackCommonParams = () => {
        return genCommonParams();
    };
}
